// extracted by extract-css-chunks-webpack-plugin
module.exports = {"customAddToCartWrapper":"Y8cCx","addToCartBlock":"jvg-Q","infoContainer":"CLS-Q"};